interface TTrusteEU {
  clickListener: () => void
  addEventListener: (listener: (topic: string) => void) => void
}

interface TTrusteCMA {
  callApi: <T>(...args: any[]) => T
}

export interface TTruste {
  eu: TTrusteEU
  cma: TTrusteCMA
}

export enum TRUSTE_CONSENT {
  DENIED = 'denied',
  APPROVED = 'approved',
}

export enum TRUSTE_CONSENT_DECISION {
  ALL = 0,
  REQUIRED = 1,
  FUNCTIONAL = 2,
  ADVERTISING = 3,
}
